import ApiClient from '@/api/ApiClient';
import { generateFormData } from '@/utils/tools';
import { ARMADO_URL } from '@/utils/CONST';

const client = new ApiClient('tempworker/timeticketattachment');

class TimeTicketAttachmentApiTempWorker {

	static add (addTimeTicketAttachmentModel: IAddTimeTicketAttachmentModel) {
		const formData = generateFormData(addTimeTicketAttachmentModel);

		return client.post<ITimeTicketAttachmentModel>('', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
	}

	static delete (id: number) {
		return client.delete<void>(id.toString());
	}

	static download (idsQuery: string) {
		client.windowOpen(`${ARMADO_URL}/app/tempworker/timeticketattachment${idsQuery}&isDownload=true`, '_blank');
	}

	static view (idsQuery: string) {
		client.windowOpen(`${ARMADO_URL}/app/tempworker/timeticketattachment${idsQuery}`, '_blank');
	}
}

export default TimeTicketAttachmentApiTempWorker;
